import { RECENT_CATCH_LIMIT_DAYS } from '../../constants/constants';
import { getTimeDifferenceBetweenDates } from '../date/getTimeDifferenceBetweenDates';

const MILLISECONDS_IN_SECONDS = 1000;
const RECENT_CATCH_LIMIT_MILLISECONDS =
  RECENT_CATCH_LIMIT_DAYS * 24 * 60 * 60 * MILLISECONDS_IN_SECONDS;

/**
 * Checks if a catch is considered new based on the time it was caught.
 *
 * A catch is considered new if it was caught within the last 14 days.
 *
 * @param {Date} caughtAtGMT - The date and time when the catch was made in GMT.
 * @returns {boolean} - Returns `true` if the catch is new, otherwise `false`.
 */
export function isCatchNew(caughtAtGMT: Date): boolean {
  const differenceToNow = getTimeDifferenceBetweenDates(new Date(), caughtAtGMT);
  return differenceToNow <= RECENT_CATCH_LIMIT_MILLISECONDS;
}
